import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { TextField } from '@mui/material'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { createStyles, makeStyles } from '@mui/styles'

// import { Logger, LoggerTypes } from '../../../utils'
import { variantTypes } from '../../../constants'
import './style.scss'

const useStyles = makeStyles((theme) =>
  createStyles({
    iconColor: {
      color: theme.palette.primary.main
    }
  })
)

export const FormSearchField = ({ searchTerm, onSearch, placeholder, widthSize, className, iconClassName }) => {
  const { t } = useTranslation()
  const styleClasses = useStyles()

  // Logger.trace(LoggerTypes.CONTAINER, 'FormSearchField.render()', { searchTerm, placeholder, widthSize })

  return (
    <div className={`search-container ${className}`} style={widthSize ? { width: widthSize } : null}>
      <SearchOutlinedIcon className={`search-container-icon ${styleClasses.iconColor} ${iconClassName}`} />
      <TextField
        id="input-with-sx"
        value={searchTerm}
        onChange={onSearch}
        inputProps={{ style: { fontSize: 13 } }}
        InputLabelProps={{ style: { fontSize: 13 } }}
        placeholder={placeholder ? placeholder : t('common.placeholders.search')}
        focused
        variant={variantTypes.OUTLINED}
      />
    </div>
  )
}

FormSearchField.displayName = 'FormSearchField'

FormSearchField.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  widthSize: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string
}

FormSearchField.defaultProps = {
  searchTerm: '',
  placeholder: null,
  onSearch: () => {},
  widthSize: null,
  className: '',
  iconClassName: ''
}
